module.exports = __webpack_public_path__ + "whitelotusflower.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitelotusflower.png
// module id = 893
// module chunks = 0